module.exports = __webpack_public_path__ + "img/IMG_1627_Black.a40c239e.jpg";